import React, {useContext} from "react";
import ApplicationContext from "./ApplicationContext";
import './title.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/fontawesome-free-solid'


export default function Title(props){

    const {scrollto} = useContext(ApplicationContext);

    return(
        <div className="Title_main">
            <span className="Title_main_text">{props.text}</span>
            <FontAwesomeIcon icon={faArrowUp} onClick={() => scrollto('app')} className="Title_main_arrow_up" />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/Title.js